// extracted by mini-css-extract-plugin
export default {"label":"G7f47c5 G5e8471"};